import React from 'react';
import {
	Grid,
	TextField,
	MenuItem
} from '@mui/material';

export default function SelectTrigger({ form, ruleTriggers, donorDefault }) {
	const { values, setFieldValue, } = form;
	const [errors, setErrors] = React.useState({});

	return (
		<Grid container direction="row" justify="center" alignItems="center">
			<Grid item xs={12}>
				<p>Name:</p>
				<TextField
					placeholder="Name"
					fullWidth
					values={values.name}
					onChange={e => setFieldValue('name', e.target.value)}
					error={errors.name || form.errors.name}
					defaultValue={values.name}
					disabled={false/*donorDefault*/}
					styles={{backgroundColor: '#ccc'}}
				/>
			</Grid>
			<Grid item xs={12}>
				<p>Notification Rule Trigger:</p>
				<TextField
					disabled={donorDefault}
					select
					fullWidth
					value={values.ruleTrigger}
					defaultValue={values.ruleTrigger}
					onChange={(_, { props }) => setFieldValue('ruleTrigger', props.value)}
					error={errors.ruleTrigger || form.errors.ruleTrigger}
				>
					{ ruleTriggers.map(item => (<MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>))}
				</TextField>
			</Grid>
		</Grid>
	);
}
